import { JSX } from "preact";
import classNames from "classnames";

/**
 * CTASection - A modern call-to-action section component
 * 
 * This component provides a clean, modern layout for call-to-action sections
 * with title, description, and button components that can be arranged in a visually appealing way.
 * 
 * Example usage:
 * ```mdx
 * <CTASection>
 *   ## Let's secure your future.
 *   
 *   Don't leave your business vulnerable to cyber threats. Partner with Gage
 *   Technologies and build a robust cybersecurity strategy that protects your assets
 *   and ensures peace of mind.
 *   
 *   <CTAButtons>
 *     <ButtonCTA href="/contact">Contact Gage for Cybersecurity Solutions</ButtonCTA>
 *     <ButtonCTA href="/solutions">Explore Our Solutions</ButtonCTA>
 *   </CTAButtons>
 * </CTASection>
 * ```
 */

export function CTASection(props: { children: JSX.Element; accent?: boolean; imageSrc?: string }) {
  return (
    <div class={classNames("cta-section", props.accent && "accent")}>
      <div class="cta-content">
        {props.children}
      </div>
      {props.imageSrc && (
        <div class="cta-image">
          <img src={props.imageSrc} alt="Gage Technologies call to action" />
        </div>
      )}
    </div>
  );
}

export function CTAButtons(props: { children: JSX.Element }) {
  return <div class="cta-buttons">{props.children}</div>;
}